import { getIdToken, signInWithCustomToken, signOut } from "firebase/auth";
import { auth } from '../integrations/Firebase'
import { showErrorToast } from "./Toasts";

export const signInWithCustomTokenFirebase = async (customToken) => {
  try {
    const userCredential = await signInWithCustomToken(auth, customToken);
    const freshToken = await getIdToken(userCredential.user, true); // true forces a refresh
    return freshToken;
  } catch (error) {
    console.error("Sign in failed:", error);
    showErrorToast("உள்நுழைவதில் தோல்வி. மீண்டும் உள்நுழையவும்...");
    return null;
  }
};

export const logoutFibreBase = async () => {
  signOut(auth)
    .then(() => {
      console.log("User signed out successfully");
      // Optionally, redirect or clear any client-side session data here.
    })
    .catch((error) => {
      console.error("Error signing out: ", error.message);
    });
};